// extracted by mini-css-extract-plugin
module.exports = {"srOnlyFocus":"classes_srOnlyFocus__r7He1","srOnly":"classes_srOnly__1Q8Zg","skeleton":"classes_skeleton__LoQKc","skeleton-animation":"classes_skeleton-animation__A66DZ"};